import React, { useState } from 'react';
import { Brain, ChevronDown, ChevronUp, Loader2, Sparkles } from 'lucide-react';

const AIThoughtBox = ({ content, isStreaming = false }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    if (!content && !isStreaming) return null;

    return (
        <div className="w-full mb-5 group animate-in fade-in slide-in-from-top-3 duration-700 ease-out">
            <div className="relative overflow-hidden rounded-2xl border border-gray-100 bg-gradient-to-br from-gray-50/50 to-white/30 backdrop-blur-sm transition-all duration-300 hover:shadow-md hover:border-blue-100/50">
                {/* Subtle top accent line */}
                <div className="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-blue-400/20 via-blue-500/40 to-blue-400/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                
                <button
                    onClick={() => setIsExpanded(!isExpanded)}
                    className="w-full flex items-center justify-between px-5 py-3 transition-colors text-left"
                >
                    <div className="flex items-center gap-3">
                        <div className={`flex items-center justify-center w-7 h-7 rounded-xl transition-all duration-500 ${isStreaming ? 'bg-blue-600 text-white shadow-lg shadow-blue-200' : 'bg-blue-50 text-blue-600'}`}>
                            {isStreaming ? (
                                <Sparkles size={14} className="animate-pulse" />
                            ) : (
                                <Brain size={14} className="group-hover:scale-110 transition-transform" />
                            )}
                        </div>
                        <div className="flex flex-col">
                            <span className="text-[10px] font-bold text-blue-600/80 uppercase tracking-widest leading-none mb-1">
                                Inner Monologue
                            </span>
                            <span className="text-xs font-semibold text-gray-700">
                                {isStreaming ? 'Analyzing & Planning...' : 'Reasoning Process'}
                            </span>
                        </div>
                        {isStreaming && (
                            <div className="flex gap-0.5 ml-2">
                                <span className="w-1 h-1 rounded-full bg-blue-400 animate-bounce [animation-delay:-0.3s]" />
                                <span className="w-1 h-1 rounded-full bg-blue-400 animate-bounce [animation-delay:-0.15s]" />
                                <span className="w-1 h-1 rounded-full bg-blue-400 animate-bounce" />
                            </div>
                        )}
                    </div>
                    <div className={`p-1 rounded-lg transition-all duration-300 ${isExpanded ? 'bg-gray-100/50 text-gray-600 rotate-0' : 'bg-transparent text-gray-400 -rotate-90'}`}>
                        <ChevronDown size={14} />
                    </div>
                </button>

                <div className={`grid transition-all duration-500 ease-in-out ${isExpanded ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}>
                    <div className="overflow-hidden">
                        <div className="px-5 pb-5 pt-1">
                            <div className="relative pl-5 py-1 border-l-2 border-blue-100/50">
                                <p className="text-[13px] leading-relaxed text-gray-500 italic font-medium">
                                    {content}
                                    {isStreaming && (
                                        <span className="inline-block w-1.5 h-4 bg-blue-500/30 ml-1 rounded-sm animate-pulse align-middle" />
                                    )}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AIThoughtBox;
